import {Messages} from '../../constants';

const validation = {
  nacionalidade: {
    presence: {
      message: Messages.RequiredNationalityDocumentValidationMessage,
      allowEmpty: false,
    },
  },
  uf: {
    presence: {
      message: Messages.RequiredBirthstateRequiredMessage,
      allowEmpty: false,
    },
  },
  cidade: {
    presence: {
      message: Messages.RequiredBirthcityRequiredMessage,
      allowEmpty: false,
    },
  },
  estadoCivil: {
    presence: {
      message: Messages.RequiredMaritalStatusValidationMessage,
      allowEmpty: false,
    },
  },
  nomeDaMae: {
    length: {
      maximum: 100,
      message: Messages.MothernameTooLongValidationRequiredMessage,
    },
    presence: {
      message: Messages.RequiredMothernameValidationRequiredMessage,
      allowEmpty: false,
    },
    format: {
      pattern: /(\w.+\s).+/i,
      message: Messages.RequiredNameFullValidationRequiredMessage,
    },
  },
};

export default validation;
